export default class Fix {
  static newline(subject: string | undefined): string {
    if (!subject) return '';
    return subject
      .replace(/\\+r\\+n/ig, '\n')
      .replace(/\\+n/ig, '\n');
    // .replace(/\n+/ig, '\n');
  }
}
